/**
 * Видео в галерее квеста: до запуска — обложка с кнопкой play,
 * после — штатные контролы. Уходит из вида (пролистали слайд
 * или страницу) — ставится на паузу.
 */
export function initQuestVideos(): void {
  document.querySelectorAll<HTMLElement>('[data-quest-video]').forEach((el) => {
    const video = el.querySelector('video')
    const play = el.querySelector<HTMLButtonElement>('[data-quest-video-play]')

    if (!video || !play) {
      return
    }

    play.addEventListener('click', () => {
      video.controls = true
      play.hidden = true
      void video.play()
    })

    new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          video.pause()
        }
      },
      { threshold: 0.5 }
    ).observe(video)
  })
}
